function positiveInteger(value) {
  const parsed = Number(value || 0);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.round(parsed));
}

export function buildCheckoutPlanProgressSummary({
  planBillingState,
  planDueTodayCents = 0,
} = {}) {
  const planTotalCents = positiveInteger(
    planBillingState?.final_total_centavos
      ?? planBillingState?.total_centavos
      ?? planBillingState?.plan_total_items_centavos
      ?? 0,
  );
  const collectedSoFarCents = positiveInteger(planBillingState?.paid_centavos);
  const databaseRemainingCents = positiveInteger(planBillingState?.remaining_centavos);
  const calculatedRemainingCents = Math.max(0, planTotalCents - collectedSoFarCents);
  const preCheckoutBalanceCents = Math.max(databaseRemainingCents, calculatedRemainingCents);
  const currentBalanceCents = preCheckoutBalanceCents;
  const stagedTodayCents = positiveInteger(planDueTodayCents);
  const projectedRemainingCents = Math.max(0, preCheckoutBalanceCents - stagedTodayCents);
  const completedVisits = positiveInteger(planBillingState?.completed_visits);
  const totalVisits = positiveInteger(planBillingState?.total_visits);
  const currentVisitNumber = totalVisits > 0
    ? Math.min(totalVisits, completedVisits + 1)
    : null;

  return {
    planTotalCents,
    collectedSoFarCents,
    databaseRemainingCents,
    preCheckoutBalanceCents,
    currentBalanceCents,
    stagedTodayCents,
    projectedRemainingCents,
    completedVisits,
    totalVisits,
    currentVisitNumber,
  };
}
